import Swal from 'sweetalert2';

const myForm = document.getElementById("mynewsletter");
if (document.querySelector("#mynewsletter")) {
    myForm.addEventListener("freeform-ajax-success", function (event) {
        const message = document.querySelector('#mynewsletter .ff-form-success > p');
        const rowform = document.querySelector("#mynewsletter .row");
        let textalert = message.textContent;
        message.setAttribute('class', 'd-none');
        //rowform.classList.remove("row");
        rowform.classList.add("form-row");
        rowform.classList.add("form");
        rowform.classList.add("newsletter--form");
        rowform.innerHTML="";
        rowform.innerHTML=`<div class="datosform d-flex col-12 p-0">
        <input type="email" name="email" class="form-control ps-4" placeholder="Correo electrónico" aria-describedby="basic-addon2">
        <button class="btn" data-freeform-action="submit" type="submit" id="button-addon2" data-original-text="" data-loading-text="null">
        <svg width="25" height="19" viewBox="0 0 25 19" xmlns="http://www.w3.org/2000/svg">
       <path d="m24.632 8.584-7.253-7.252a1.283 1.283 0 0 0-1.821 0 1.283 1.283 0 0 0 0 1.82l5.053 5.053H1.295a1.294 1.294 0 1 0 0 2.59H20.6l-5.053 5.052a1.283 1.283 0 0 0 0 1.821 1.283 1.283 0 0 0 1.821 0l7.253-7.252c.253-.253.379-.58.379-.916 0-.337-.116-.663-.368-.916z" fill="#101C82" fill-rule="nonzero"></path>
       </svg></button></div>`;
        Swal.fire(
            'Newsletter',
            ''+textalert,
            'success'
        );
    });
}